/**
 * Created by stavmeidan on 3/24/16.
 */

'use strict';

var endpoints = require('dibs-endpoints');
var FeeStructure = require('bunsen/models/ecomm/FeeStructure');
var SoaCollection = require('bunsen/collections/SoaCollection');

module.exports = SoaCollection.extend({
    url: endpoints.feeStructures,
    model: FeeStructure,

    /**
     * gets rate card type
     * @returns {String} - either "TIERED" or "FLAT"
     */
    getRateType: function () {
        var first = this.first();
        return first && first.get('rateType'); // will always be first element in list
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/FeeStructures.js
// module id = 2616
// module chunks = 64